import { render, staticRenderFns } from "./current-liquidations.vue?vue&type=template&id=06712403"
import script from "./current-liquidations.vue?vue&type=script&lang=js"
export * from "./current-liquidations.vue?vue&type=script&lang=js"
import style0 from "./current-liquidations.vue?vue&type=style&index=0&id=06712403&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports